import React, { useState } from "react";
import {Modal, ModalContent, ModalHeader, ModalBody, ModalFooter, Button, useDisclosure, Spinner, Input} from "@nextui-org/react";
import { toast } from "react-toastify";
import { orders_uri } from "../../utils/url";
import { POST } from "../../utils/requests";

export default function DeliveryDeclined({callback, user}) {
  const {isOpen, onOpen, onOpenChange} = useDisclosure();
  const [load, setLoad] = useState(false);

  const handlecal = () => {
    callback();
  }

  const Sub = async () => {
    setLoad(true);
    try{
        const res = await POST({uri:orders_uri+'/delivery/declined', data:{phone: user.user.phone_no, deposit: user.user.deposit, user_id: user.user_id, id: user.id}});
        if(res.status === 200){
          setLoad(false);
          toast.success("Амжилттай");
          onOpenChange(false);
          handlecal();
        }
        setLoad(false);
    }catch(err){
        console.log(err);
        setLoad(false);
    }
  }

  return (
    <>
      <Button onPress={onOpen}>Буцаах</Button>
      <Modal isOpen={isOpen} onOpenChange={onOpenChange} scrollBehavior='inside' size="md">
        <ModalContent>
          {(onClose) => (
            <>
              <ModalBody>
                <div className="font-Roboto mt-6">
                    <h1 className="m-2 uppercase font-bold text-center">Та буцаахдаа итгэлтэй байна уу ?</h1>
                </div>
              </ModalBody>
              <ModalFooter>
                <Button color="danger" variant="light" onPress={onClose}>
                  Болих
                </Button>
                {
                  load?
                  <Button color="primary">
                    <Spinner color="white"/>
                  </Button>
                  :
                  <Button color="primary" onPress={Sub}>
                    Буцаах
                  </Button>
                }
              </ModalFooter>
            </>
          )}
        </ModalContent>
      </Modal>
    </>
  );
}